import React from "react";

/**
 * ListeningPanel — horizontal player BAR for step 3 (Listening).
 *
 * Sits above the scenario card (full width). Left: play/stop button + label +
 * play-count text. Right: 3-dot progress. Drives existing logic via props.
 */
export default function ListeningPanel({
  playCount = 0,
  required = 3,
  isPlaying = false,
  locked = false,
  done = false,
  onPlay = () => {},
  onStop = () => {},
}) {
  const count = Math.min(playCount, required);
  const remaining = Math.max(required - count, 0);

  const statusText = locked
    ? "Finish reading first to unlock"
    : done
    ? "Completed — Role Play unlocked"
    : `${count} of ${required} plays · ${remaining} more to unlock`;

  return (
    <div className="surface-glass flex items-center gap-3 sm:gap-4 px-3 sm:px-4 py-3 rounded-xl">
      <button
        type="button"
        onClick={isPlaying ? onStop : onPlay}
        disabled={locked}
        className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-dt-gold text-dt-ink flex items-center justify-center hover:brightness-105 disabled:opacity-50 disabled:cursor-not-allowed shadow-soft transition-[filter] shrink-0"
        aria-label={isPlaying ? "Stop" : "Play full dialogue"}
      >
        {isPlaying ? <StopIcon /> : <PlayIcon />}
      </button>

      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-ink-800">
          {isPlaying ? "Playing…" : "Play the full dialogue"}
        </div>
        <div className="text-xs text-ink-400 mt-0.5">{statusText}</div>
      </div>

      <div className="flex gap-1.5 shrink-0">
        {Array.from({ length: required }).map((_, i) => (
          <span
            key={i}
            className={`w-6 sm:w-7 h-1.5 rounded-full ${
              i < count ? "bg-dt-gold" : "bg-dt-forest-soft"
            }`}
          />
        ))}
      </div>
    </div>
  );
}

function PlayIcon() {
  return (
    <svg className="w-6 h-6 sm:w-7 sm:h-7" fill="currentColor" viewBox="0 0 24 24">
      <path d="M8 5v14l11-7z" />
    </svg>
  );
}
function StopIcon() {
  return (
    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
      <rect x="6" y="6" width="12" height="12" rx="2" />
    </svg>
  );
}
